var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.285,
    height: 14.762,
    viewBox: "0 0 13.285 14.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5342",
    "data-name": "Rectangle 5342",
    width: 13.285,
    height: 14.762,
    fill: "#faf8f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15356",
    "data-name": "Group 15356",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15355",
    "data-name": "Group 15355",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29461",
    "data-name": "Path 29461",
    d: "M5.166,4.428H9.595a.738.738,0,1,0,0-1.476H5.166a.738.738,0,1,0,0,1.476M3.69,7.381h5.9a.738.738,0,1,0,0-1.476H3.69a.738.738,0,1,0,0,1.476m0,2.952h5.9a.738.738,0,1,0,0-1.476H3.69a.738.738,0,0,0,0,1.476M12.547,0H.738A.738.738,0,0,0,0,.738V14.023a.738.738,0,0,0,1.18.592L2.71,13.47l1.518,1.145a.744.744,0,0,0,.888,0L6.643,13.47l1.526,1.145a.744.744,0,0,0,.888,0l1.518-1.145,1.53,1.145a.741.741,0,0,0,1.18-.592V.738A.738.738,0,0,0,12.547,0m-.738,12.547-.788-.592a.744.744,0,0,0-.888,0L8.615,13.1l-1.53-1.145a.738.738,0,0,0-.884,0L4.67,13.1,3.152,11.955a.744.744,0,0,0-.888,0l-.788.592V1.476H11.809Z",
    transform: "translate(0 0)",
    fill: "#faf8f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.7cd4f131db73480e488ae1ceec6aa602.svg";
export { ForwardRef as ReactComponent };